import api from '@pray/shared/utils/api';

export type TriggerQueuesResponse = undefined;

/**
 * Trigger queues processing
 */
export async function triggerQueues() {
  const url = '/web/studio/queues/trigger';
  const response = await api.executePostRequest<TriggerQueuesResponse>(url);

  return response.data;
}
